import { EventComponent, PlannerEcsSystem, ProductInfoComponent, SuspensionRailComponent } from '../..';
import { ComponentIds, HierarchyUtils } from '@inter-ikea-core/core';
/**
 * This system listen to history events and adds suspension rails for all hanging frames and
 * frames stacked with the top above specified height.
 */
export class SuspensionRailSystem extends PlannerEcsSystem {
    constructor(coreApi, frameIgnoredProductTypes, suspensionRailProductType, stackedFrameTopHeight, systemName) {
        super(coreApi, systemName || 'SuspensionRailSystem', EventComponent.id);
        this.suspensionRailProducts = [];
        this.frameIgnoredProductTypes = [];
        this.suspensionRailProductType = suspensionRailProductType;
        this.coreApi = coreApi;
        this.stackedFrameTopHeight = stackedFrameTopHeight;
        this.frameIgnoredProductTypes = frameIgnoredProductTypes;
        this.systemName = systemName;
    }
    setMarketProducts(marketProducts) {
        this.suspensionRailProducts = marketProducts.filter(p => p.type === this.suspensionRailProductType);
    }
    onAdd() { }
    onUpdate(entity, oldComponent, newComponent) {
        if (newComponent.event === 'history') {
            if (this.suspensionRailProducts.length === 0) {
                return;
            }
            this.removeSuspensionRails();
            const frames = this.coreApi.entities.getByComponent(ComponentIds.FRAME_COMPONENT_ID);
            const validFrames = frames.filter(f => {
                if (this.frameIgnoredProductTypes && this.frameIgnoredProductTypes.length > 0) {
                    return !this.frameIgnoredProductTypes.find(s => s === f.getComponent(ProductInfoComponent.id)?.productType);
                }
                else {
                    return f;
                }
            });
            const framesNeedingSuspensionRail = [];
            validFrames.forEach(frame => {
                if ((this.isFrameWallHanging(frame) || this.isFrameTopAboveStackedFrameTopHeight(frame)) &&
                    this.isFrameWithoutLegs(frame)) {
                    framesNeedingSuspensionRail.push(frame);
                }
            });
            this.addSuspensionRails(framesNeedingSuspensionRail);
        }
    }
    onRemove() { }
    removeSuspensionRails() {
        const suspensionRails = this.coreApi.entities.getByProductType(this.suspensionRailProductType);
        if (suspensionRails.length > 0) {
            this.coreApi.entities.deleteMultiple(suspensionRails);
        }
    }
    addSuspensionRails(frames) {
        frames.forEach(frame => {
            const frameWidth = this.coreApi.entities.getEntityComSize(frame)?.width || 0;
            const nbrOfRails = frame.getComponent(SuspensionRailComponent.id)?.nbrOfRails || 1;
            const suspensionRailProduct = this.suspensionRailProducts.find(p => {
                return p.communicatedDimensions.width === frameWidth;
            }) ||
                this.suspensionRailProducts.find(p => {
                    return frameWidth % p.communicatedDimensions.width === 0;
                });
            const suspensionRailEntities = suspensionRailProduct
                ? new Array(nbrOfRails)
                    .fill(suspensionRailProduct)
                    .map(product => this.coreApi.entities.create(product.coreProductId))
                    .filter(Boolean)
                : [];
            if (suspensionRailEntities.length > 0) {
                suspensionRailEntities.forEach(suspensionRailEntity => this.coreApi.entities.placementService.forcePlaceEntity(suspensionRailEntity));
            }
        });
    }
    isFrameWallHanging(frame) {
        return !this.coreApi.entities.isPartOfFloorstandingStack(frame);
    }
    isFrameTopAboveStackedFrameTopHeight(frame) {
        if (!this.stackedFrameTopHeight) {
            return false;
        }
        const position = frame.getComponent(ComponentIds.WORLD_TRANSFORM_COMPONENT_ID)?.transform.position;
        const frameHeight = this.coreApi.entities.getEntityComSize(frame)?.height;
        return position && frameHeight && position.Y + frameHeight / 2 > this.stackedFrameTopHeight;
    }
    isFrameWithoutLegs(frame) {
        return !HierarchyUtils.children(frame).find(c => c.hasComponent(ComponentIds.LEG_COMPONENT_ID));
    }
}
//# sourceMappingURL=SuspensionRailSystem.js.map